import React from 'react'
import { Tabs, Tab, ButtonToolbar } from 'react-bootstrap'
import { saveAs } from 'file-saver'

import * as unitService from '../../services/organizational-units-service'
import * as locationService from '../../services/location-service'
import * as collaboratorService from '../../services/collaborator-service'

import Topbar from '../Topbar'
import Locations from '../Locations/index'
import Organizationalunits from '../Organizationalunits'
import Collaborators from '../Collaborators'
import OrganizationalUnitModal from '../Organizationalunits/modal/OrganizationalUnitModal'
import DownloadModal from '../../components/DownloadModal'
import ImportModal from '../../components/ImportModal'
import LocationModal from '../Locations/modal/LocationModal'
import CollaboratorModal from '../Collaborators/modals/CollaboratorModal'

export default class OrganizationOverview extends React.Component {
  constructor() {
    super()
    this.handleSelect = this.handleSelect.bind(this)
    this.state = {
      units: [],
      locations: [],
      collaborators: [],
      key: 1
    }
  }

  componentDidMount() {
    this.refreshTable()
  }

  handleSelect(key) {
    this.setState({ key })
  }

  exportTemplate() {
    collaboratorService.exportCollaborator().then(x => this.save(x, 'sjabloon.xlsx'))
  }

  save(result, filename) {
    let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, filename)
  }

  refreshTable() {
    unitService.getUnits().then((units) => this.setState({units: units}))
    locationService.getLocations().then((locations) => this.setState({locations: locations}))
    collaboratorService.getCollaborators().then((collaborators) => {
      let fullName = collaborators.map((col) =>
        { col.fullName = col.lastName + ", " + col.firstName + " " + (col.prefix || "")
          return col})
       this.setState({collaborators: fullName})})
  }

  render() {
    return (
      <div className="content table-page unit-overview">
        <div className="content-inner">
          <Topbar title="Organisatie" />

          <div className="inner">
            <div className="table-actions">
              <ButtonToolbar>
                {this.state.key === 1 &&
                  <React.Fragment>
                    <LocationModal 
                      title="Nieuwe locatie"
                      textbt="Nieuw" 
                      modalbttext="Toevoegen" 
                      reload={() => this.refreshTable()}/>
                  </React.Fragment>
                }
                {this.state.key === 2 &&
                  <React.Fragment>
                    <OrganizationalUnitModal
                      title="Nieuwe organisatorische eenheid"
                      textbt="Nieuw"
                      text="Wilt u een organisatorische eenheid toevoegen?"
                      modalbttext="Toevoegen"
                      reload={() => this.refreshTable()}/>
                  </React.Fragment>
                }
                {this.state.key === 3 &&
                  <React.Fragment>
                    <CollaboratorModal
                      title="Nieuwe medewerker"
                      textbt="Nieuw"
                      modalbttext="Toevoegen"
                      text="Wilt u een medewerker toevoegen? De medewerker krijgt hiervan pas een melding als hij / zij geraadpleegd wordt in een scan."
                      reload={() => this.refreshTable()}/>
                  </React.Fragment>
                }
                <DownloadModal
                  text="Wilt u tegelijk meerdere medewerkers importeren? Hier kunt u het sjabloon downloaden dat u hiervoor kunt gebruiken. Als de gewenste medewerkers op de juiste manier in het sjabloon staan, kunt u dit bestand importeren in BrandWijzer.<br/><br/>Let op de juiste schrijfwijze van de organisatorische eenheden en locaties!<br/><br/>Wilt u het sjabloon downloaden?"
                  title="Download sjabloon"
                  modalbtntext="Downloaden"
                  textbtn="Download sjabloon"
                  export={() => this.exportTemplate()}/>

                <ImportModal
                  title="Importeer bestand"
                  importtype="collaborators"
                  text="Wilt u tegelijk meerdere medewerkers importeren? Hiervoor kunt u een .xls, .xlsx of .csv-bestand importeren. Dit bestand moet uit een vaste indeling bestaan, download hiervoor eerst het sjabloon."
                  textbt="Importeer"
                  reload={() => this.refreshTable()}/>
              </ButtonToolbar>
            </div>

            <Tabs id='tabs' activeKey={this.state.key} onSelect={this.handleSelect}>
              <Tab eventKey={1} title='Locaties'>
                <Locations refresh={() => this.refreshTable()} locations={this.state.locations} />
              </Tab>
              <Tab eventKey={2} title='Organisatorische eenheden'>
                <Organizationalunits refresh={() => this.refreshTable()} units={this.state.units} />
              </Tab>
              <Tab eventKey={3} title='Medewerkers'>
                <Collaborators refresh={() => this.refreshTable()} collaborators={this.state.collaborators} />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/OrganizationsOverview/index.js